import React from 'react';
import MultipleUnpublishMerchants
  from '@/Pages/Merchants/Assets/MultiplePublicMerchantsAction/MultipleUnpublishMerchants';
import MultipleShowMerchants from '@/Pages/Merchants/Assets/MultiplePublicMerchantsAction/MultipleShowMerchants';
import MultipleHideMerchants from '@/Pages/Merchants/Assets/MultiplePublicMerchantsAction/MultipleHideMerchants';

const MultiplePublicMerchantsAction = ({checked}) => {
  return (
    <div className='flex'>
      <MultipleUnpublishMerchants checked={checked}/>
      <MultipleShowMerchants checked={checked}/>
      <MultipleHideMerchants checked={checked}/>
    </div>
  );
};

export default MultiplePublicMerchantsAction;
